import { render, staticRenderFns } from "./actes.vue?vue&type=template&id=b2d01b6c&"
import script from "./actes.vue?vue&type=script&lang=js&"
export * from "./actes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports